import EmphasizedContent from '@blocks/EmphasizedContent'
import Grid from '@blocks/Grid'
import React from 'react'
import { useFinishedDashboardContext } from '../../context'
import FinishedSection from './components/FinishedSection'

export default function FinishedSections() {
    const { finished } = useFinishedDashboardContext()

    return (
        <Grid gap="5px">
            <small>Limits</small>
            <Grid columns="4">
                {finished.data.sections.map(section => <FinishedSection key={section.id} {...section} />)}
            </Grid>
        </Grid>
    )
}